<template>
  <div
    id="error-checkin"
    aria-hidden="true"
    class="modal fade"
    data-backdrop="exampleModalLabel"
    data-keyboard="false"
    tabindex="-1"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-body p-0">
          <button class="close" data-bs-dismiss="modal" type="button">
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="check-in container text-white m-0">
            <h2 class="font-weight-bold">Error</h2>
            <p v-if="$store.state.error.message" class="py-5">
              {{ $store.state.error.message }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup></script>

<style></style>
